
import SectorReportsWrapper from '@/components/marketAnalysis/SectorReportsWrapper';

export default {
    name: 'SectorReportsSection',

    components: {
        SectorReportsWrapper,
    },

    data() {
        return {
            seclectedSector: null,
        };
    },
}
